import { createFileRoute } from '@tanstack/react-router';
import { LayoutDoPainel } from '@/components/layout/LayoutDoPainel';
import { exigirSessao } from '@/features/auth/guardas';
import { TemaDaEmpresa } from '@/features/personalizacao/componentes/TemaDaEmpresa';

/**
 * Tudo que exige sessão da equipe: guarda da sessão (spec 002), layout do painel (spec 003) e as
 * cores da empresa (spec 012).
 */
export const Route = createFileRoute('/_autenticado')({
  beforeLoad: async ({ context, location }) => ({ me: await exigirSessao(context, location) }),
  component: Painel,
});

function Painel() {
  return (
    <>
      <TemaDaEmpresa />
      <LayoutDoPainel />
    </>
  );
}
